import { render, staticRenderFns } from "./InstallationsSideviewAppointmentsTab.vue?vue&type=template&id=df228b20&scoped=true&class=fill-height&"
import script from "./InstallationsSideviewAppointmentsTab.vue?vue&type=script&lang=ts&"
export * from "./InstallationsSideviewAppointmentsTab.vue?vue&type=script&lang=ts&"
import style0 from "./InstallationsSideviewAppointmentsTab.vue?vue&type=style&index=0&id=df228b20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df228b20",
  null
  
)

export default component.exports